// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dt4m","name":"styles_name__-gPHB","phone":"styles_phone__17p5y"};